import { useDataChainId } from '@ui/hooks/datachain';
import { Menu } from '@ui/lib/park/ui/menu';

import { TokenOption } from './TokenOption';
import { CollateralTokenPickerProps } from './type';

export const PickerMenu = ({
  payableTokens,
  onSelect,
  children,
}: CollateralTokenPickerProps) => {
  const chainId = useDataChainId();

  return (
    <Menu.Root
      lazyMount
      unmountOnExit
      positioning={{
        placement: 'bottom',
      }}
      onSelect={(v) => {
        const token = payableTokens.find((t) => t.symbol === v.value);
        if (!token) {
          throw new Error('Token not found: ' + v.value + ' ' + chainId);
        }

        onSelect(token);
      }}
    >
      <Menu.Trigger asChild flexShrink={0}>
        {children}
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content
          bg="v2.bg.panel"
          border="1px solid"
          borderColor="v2.border.default"
          borderRadius="4px"
          overflowY="auto"
        >
          <Menu.ItemGroup overflowY="auto">
            {payableTokens.map((token) => {
              return (
                <Menu.Item value={token.symbol} key={token.symbol}>
                  <TokenOption token={token} />
                </Menu.Item>
              );
            })}
          </Menu.ItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};
